import React, { useState, memo } from 'react';
import { useSlate } from 'slate-react';
import classnames from 'classnames';
import normalizeUrl from 'normalize-url';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Icon from 'components/Misc/Icon';
import { Input, Button } from 'components/Misc/Form';

// Link's button component
// @format: string | format's type
// @icon: string | icon's type
const Link = memo(() => {
	// Cache link's data
	const [data, setData] = useState({
		text: '',
		href: '',
		path: null,
		editing: false
	});

	// Cache link's container visibility
	const [visible, setVisible] = useState(false);

	// Get current editor
	const editor = useSlate();

	// Check if link is active
	const isActive = editor.isElementActive('link');

	// Check if link is disabled
	const isDisabled =  editor.isLinkDisabled();

	// Generate classnames
	const cls = classnames(
		isActive && 'bg-neutral-100 dark:bg-neutral-700',
		isDisabled
			? 'text-neutral-400 dark:text-neutral-700'
			: 'text-neutral-800 dark:text-white',
		'w-9 h-9 leading-9 rounded-lg text-xl text-center cursor-pointer transition-colors'
	);

	// Handle add link button click
	// @event: object | default onClick event
	const onInsert = event => {
		event.preventDefault();

		// Create link element in editor's selection
		editor.insertLink({
			...data,
			href: normalizeUrl(data.href, { forceHttps: true })
		});

		// Hide link's toolbar
		setVisible(false);
	};

	// Handle remove link button click
	// @event: object | default onClick event
	const onRemove = event => {
		event.preventDefault();

		// Remove link from current selection
		editor.removeLink(data);

		// Hide link's toolbar
		setVisible(false);
	};

	// Handles highlight's button click
	const onClick = () => {
		// Prevent link insertion if no selection
		if (!editor.selection) return;

		// Show link's toolbar
		setVisible(v => !v);

		// Store link's data
		setData(prev => ({
			...prev,
			...editor.prepareLink()
		}));
	};

	// Handles link's data change
	// @event: object | onChange event
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handles click outside of highlight's container
	const handleModal = () => {
		// Hide modal
		setVisible(false);

		// Reset link's state
		setData(prev => ({
			...prev,
			text: '',
			href: '',
			path: null,
			editing: false
		}));
	};

	return (
		<>
			{/* Formater's button */}
			<Icon
				icon="link"
				className={cls}
				onClick={onClick}
				disabled={isDisabled}
			/>

			{/* Additional control menu */}
			<Modal title="Ievietot saiti" visible={visible} handleModal={handleModal}>
				<div className="grid md:grid-cols-2 gap-4">
					<Input
						type="text"
						name="text"
						label="Redzamais teksts"
						value={data.text}
						onChange={onChange}
					/>

					<Input
						type="text"
						name="href"
						label="Saite"
						value={data.href}
						onChange={onChange}
					/>

					<div className="col-span-2 flex justify-end space-x-3">
						<Show if={data.editing}>
							<Button
								theme="danger"
								value="Dzēst"
								icon="delete"
								onClick={onRemove}
							/>
						</Show>

						<Button
							theme="success"
							value="Ievietot"
							icon="add"
							onClick={onInsert}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
});

export default Link;
